import { getAvailableFamilies } from "@features/administration/products/SelectProductFamily/helpers"
import { CircularProgress, MenuItem, Select, SelectProps } from "@mui/material"
import { GridRowId, useGridApiContext } from "@mui/x-data-grid"
import { useGetProductFamiliesQuery } from "@store/services/baseGraphFamiliesService"
import { useLayoutEffect, useRef } from "react"

type SelectProductFamilyProps = SelectProps & {
  productKey: string | undefined // string here structured -> organisation_key#division_key#product_key
  value: string
  hasFocus?: boolean
  field: string
  gridRowId: GridRowId
}

const SelectProductFamily = ({
  productKey,
  value,
  hasFocus,
  field,
  gridRowId,
  ...props
}: SelectProductFamilyProps) => {
  const ref = useRef<HTMLInputElement>()
  const apiRef = useGridApiContext()

  const [organisationKey, divisionKey, prodKey] = (productKey || "").split("#")

  const { isFetching, data } = useGetProductFamiliesQuery(
    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    { divisionKey, organisationKey, productKey: prodKey },
    {
      skip: !organisationKey || !divisionKey || !prodKey,
    },
  )

  useLayoutEffect(() => {
    if (hasFocus) ref?.current?.focus()
  }, [hasFocus])

  if (!productKey) return <></>
  if (isFetching) return <CircularProgress size={20} sx={{ ml: 1 }} />

  const families = data ?? []
  const availableFamilies = getAvailableFamilies(families, apiRef.current, gridRowId)

  return (
    <Select
      fullWidth
      value={value}
      ref={ref}
      onChange={({ target: { value } }) => {
        apiRef.current.setEditCellValue({ id: gridRowId, field, value })
      }}
      {...props}
    >
      {availableFamilies.map(({ family, isUsed }) => (
        <MenuItem key={family.key} value={family.key} disabled={isUsed}>
          {family.key.split("#")[3]}
        </MenuItem>
      ))}
    </Select>
  )
}

export default SelectProductFamily
